// extracted by mini-css-extract-plugin
export var backdropBlur = "_ms-0";
export var contentCard = "_ms-5";
export var frame = "_ms-2";
export var image = "_ms-4";
export var imagePane = "_ms-3";
export var modal = "_ms-1";